import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getDteEmission = async (id) =>
  (await axios.get(`${API_URL}/dte/emissions/${id}`, withAuth())).data;

export const refreshDteEmissionStatus = async (id) =>
  (await axios.get(`${API_URL}/dte/emissions/${id}/status`, withAuth())).data;

export const retryDteEmission = async (id) =>
  (await axios.post(`${API_URL}/dte/emissions/${id}/retry`, {}, withAuth())).data;

export const generateDteEmissionPdf = async (id) =>
  (await axios.post(`${API_URL}/dte/emissions/${id}/pdf`, {}, withAuth())).data;

export const getDteEmissionArtifactUrl = (id, artifact) =>
  `${API_URL}/dte/emissions/${id}/artifacts/${artifact}`;
